export const getCheckedSettings = ( state ) => state.checkedSettings
export const getCampaignSettings = ( state ) => state.campaignSettings


// WEBPACK FOOTER //
// ./src/app/campaign/vuex/getters.js